import { render, staticRenderFns } from "./MtrlList.vue?vue&type=template&id=467e9cb6&scoped=true&"
import script from "./MtrlList.vue?vue&type=script&lang=js&"
export * from "./MtrlList.vue?vue&type=script&lang=js&"
import style0 from "./MtrlList.vue?vue&type=style&index=0&id=467e9cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e9cb6",
  null
  
)

export default component.exports